import { render, staticRenderFns } from "./BulkBookingAction.vue?vue&type=template&id=4442e496&"
import script from "./BulkBookingAction.vue?vue&type=script&lang=js&"
export * from "./BulkBookingAction.vue?vue&type=script&lang=js&"
import style0 from "./BulkBookingAction.vue?vue&type=style&index=0&id=4442e496&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports